export const FOLLOW_UP_STEPS = {
  STEP_1_STUDENT_WPP: "Contato via WhatsApp - Aluno",
  STEP_2_RESPONSIBLE_WPP: "Contato via WhatsApp - Responsável",
  STEP_3_SCHOOL_CONTACT: "Contato com a Escola",
  STEP_4_HOME_VISIT: "Visita Domiciliar"
};

export function getStepLabel(step) {
  return FOLLOW_UP_STEPS[step] || step;
}
